// Transitions
export const FORM_VALID_TRANSITION_CLAIMENT_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/formValid";
export const FORM_INVALID_TRANSITION_CLAIMENT_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/formInvalid";
export const CLAIMENT_DETAILS_FORM_SET_VALUE =
  "sizotsaFuneralClaim/claimentDetails/transition/formValue";
export const setPersonalDetailFormValues = () => ({
  type: CLAIMENT_DETAILS_FORM_SET_VALUE,
});

export const transitionClaimentDetails = {
  formValid: () => ({ type: FORM_VALID_TRANSITION_CLAIMENT_DETAILS }),
  formInvalid: () => ({ type: FORM_INVALID_TRANSITION_CLAIMENT_DETAILS }),
};

export const INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/invalidContinue";
export const CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/validContinue";
export const BACK_TRANSITION_PERSONAL_DETAIL =
  "sizotsaFuneralClaim/claimentDetails/transition/back";
export const invalidContinuePersonalDetails = () => ({
  type: INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const continuePersonalDetails = () => ({
  type: CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const backPersonalDetails = () => ({
  type: BACK_TRANSITION_PERSONAL_DETAIL,
});

// Transition - reset state
export const RESET_STATE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/resetState";
export const resetPersonalDetails = () => ({
  type: RESET_STATE_TRANSITION_PERSONAL_DETAILS,
});

// Events
export const PERSONAL_DETAILS_CLEAR_VALUE =
  "sizotsaFuneralClaim/claimentDetails/clearValue/";
export const CLAIMENT_DETAILS_SET_VALUE =
  "sizotsaFuneralClaim/claimentDetails/setValue/";
export const CLAIMENT_DETAILS_FIELD_SET_VALID =
  "sizotsaFuneralClaim/claimentDetails/setValid/";

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/claimentDetails/transition/dropOffLead";
export const dropOffLeadPersonalDetails = (dropOffDetails) => ({
  type: DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS,
  dropOffDetails,
});

export const RESET_CLAIMENT_DETAILS_FORM = "sizotsaFuneralClaim/claimentDetails/resetForm"
export const resetClaimentDetailsFrom=()=>({type: RESET_CLAIMENT_DETAILS_FORM})

export const setClaimentDetailsValue =(value)=>({type: CLAIMENT_DETAILS_SET_VALUE, value})
export const setClaimentDetailsFieldValid =(error,fieldType)=>({type: CLAIMENT_DETAILS_FIELD_SET_VALID, error, value:{fieldType}})
